import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Polaroid } from './Polaroid';
import { photos } from '../data/photos';
interface CardStackProps {
  onComplete: () => void;
}
export const CardStack: React.FC<CardStackProps> = ({
  onComplete
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isFinishing, setIsFinishing] = useState(false);
  const handleSwipe = () => {
    setHasInteracted(true);
    if (currentIndex < photos.length - 1) {
      setCurrentIndex(prev => prev + 1);
    } else {
      setCurrentIndex(prev => prev + 1);
      setIsFinishing(true);
      // Wait for the celebration animation to finish before showing final screen
      setTimeout(onComplete, 2200);
    }
  };
  const handleInteract = () => {
    if (!hasInteracted) setHasInteracted(true);
  };
  // Keyboard support
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (currentIndex >= photos.length) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        handleSwipe();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);
  const visiblePhotos = photos.slice(currentIndex, currentIndex + 4);
  const displayCount = Math.min(currentIndex + 1, photos.length);
  return <div className="relative w-full h-full flex flex-col items-center justify-center" data-id="element-4">
      {/* Landing hint — fades out on first interaction */}
      <AnimatePresence data-id="element-5">
        {currentIndex === 0 && !hasInteracted && <motion.div className="absolute top-[6%] sm:top-[10%] left-0 right-0 flex flex-col items-center pointer-events-none z-50 px-6 text-center" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20,
        transition: {
          duration: 0.3
        }
      }} data-id="element-6">
            {/* === EDITEAZĂ TEXTUL DE BUN VENIT AICI === */}
            <motion.p className="font-marker font-bold text-cream text-3xl sm:text-4xl mb-3 tracking-wide" animate={{
          opacity: [0.7, 1, 0.7]
        }} transition={{
          repeat: Infinity,
          duration: 2.5,
          ease: 'easeInOut'
        }} data-id="element-7">
              Bagă swipe
            </motion.p>
            <motion.svg width="40" height="40" viewBox="0 0 40 40" fill="none" stroke="currentColor" className="text-silver" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" animate={{
          scale: [1, 1.12, 1],
          opacity: [0.5, 1, 0.5]
        }} transition={{
          repeat: Infinity,
          duration: 1.8,
          ease: 'easeInOut'
        }} aria-hidden="true" data-id="element-8">
              {/* 4-direction arrows: up, down, left, right */}
              <line x1="20" y1="6" x2="20" y2="34" data-id="element-9" />
              <line x1="6" y1="20" x2="34" y2="20" data-id="element-10" />
              <polyline points="14,12 20,6 26,12" data-id="element-11" />
              <polyline points="14,28 20,34 26,28" data-id="element-12" />
              <polyline points="12,14 6,20 12,26" data-id="element-13" />
              <polyline points="28,14 34,20 28,26" data-id="element-14" />
            </motion.svg>
          </motion.div>}
      </AnimatePresence>

      {/* Card stack area */}
      <div className="relative w-full flex items-center justify-center" style={{
      height: 'min(70vh, 480px)'
    }} data-id="element-15">
        <AnimatePresence data-id="element-16">
          {visiblePhotos.map((photo, i) => <Polaroid key={photo.id} photo={photo} isTop={i === 0} stackPosition={i} onSwipe={handleSwipe} onInteract={handleInteract} data-id="element-17" />).reverse()}
        </AnimatePresence>
      </div>

      {/* Counter — flex sibling, sits right under the stack so mobile browser chrome can never cut it off */}
      <motion.div className="font-inter text-silver text-xs sm:text-sm tracking-[0.25em] font-medium pointer-events-none z-40 mt-6 sm:mt-8" style={{
      marginBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.5rem)'
    }} initial={{
      opacity: 0
    }} animate={{
      opacity: isFinishing ? 0 : 0.85
    }} transition={{
      duration: 0.4
    }} aria-live="polite" data-id="element-18">
        {displayCount} / {photos.length}
      </motion.div>

      {/* Final celebration: big "34" appearing center before the final screen */}
      <AnimatePresence data-id="element-19">
        {isFinishing && <motion.div key="celebration" className="absolute inset-0 flex items-center justify-center pointer-events-none z-50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.5
        }
      }} transition={{
        duration: 0.3
      }} data-id="element-20">
            <motion.span className="font-marker font-bold text-cream" initial={{
          scale: 0.4,
          opacity: 0
        }} animate={{
          scale: [0.4, 1.1, 1, 1.15],
          opacity: [0, 1, 1, 0]
        }} transition={{
          duration: 2,
          times: [0, 0.35, 0.7, 1],
          ease: [0.22, 0.61, 0.36, 1]
        }} style={{
          fontSize: 'clamp(7rem, 30vw, 14rem)',
          lineHeight: 1
        }} data-id="element-21">
              {photos.length}
            </motion.span>
          </motion.div>}
      </AnimatePresence>
    </div>;
};